import {
	IconBox,
	IconBoxChecked,
	IconBoxLine,
} from '@montel/montelpro-shared-components-v2';
import React from 'react';
import { CheckboxState } from '../CheckboxTree.types';

interface CheckBoxIconProps {
	state?: CheckboxState;
	size?: string;
}

const CheckBoxIcon: React.FC<CheckBoxIconProps> = ({ state, size = 'sm' }) => {
	switch (state) {
		case CheckboxState.Checked:
			return (
				<IconBoxChecked
					color={'iconDefault'}
					boxSize={size === 'sm' ? '16px' : '24px'}
					className="checkbox-icon"
				/>
			);
		case CheckboxState.Indeterminate:
			return (
				<IconBoxLine
					color={'iconDisabled'}
					boxSize={size === 'sm' ? '16px' : '24px'}
					className="checkbox-icon indeterminate"
				/>
			);
		case CheckboxState.ImplicitlyChecked:
			return (
				<IconBoxChecked
					color={'iconDisabled'}
					boxSize={size === 'sm' ? '16px' : '24px'}
					className="checkbox-icon implicitly-checked"
				/>
			);
		default:
			return (
				<IconBox
					color={'iconSubtle'}
					boxSize={size === 'sm' ? '16px' : '24px'}
					className="checkbox-icon"
				/>
			);
	}
};

export default CheckBoxIcon;
